export function saveTokens(accessToken: string, refreshToken: string, expiresAt?: number) {
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('expiresAt', String(expiresAt));
}
